import React, { useState } from "react";
import { TemplateSectionFragment } from "../../graphql/fragments/TemplateSection";
import { ChevronDownIcon } from "../icons";
import useTranslations from "../../hooks/useTranslations";

import {
  H3,
} from "../wombat-ui";

type TemplateSectionProps = {
  section: TemplateSectionFragment;
  children: React.ReactNode[] | React.ReactNode;
  displayedIndex: string;
  defaultOpen: boolean;
};

const TemplateSection: React.FC<TemplateSectionProps> = ({
  section,
  children,
  displayedIndex,
  defaultOpen = false
}) => {
  const t = useTranslations();

  const [sectionOpen, setSectionOpen] = useState(defaultOpen);

  if (section.type === "TemplateSectionBlank") {
    return (
      <>
        {children}
      </>
    );
  }

  return (
    <div className={`px-4 py-3 bg-white rounded shadow`}>
      <div
        className="flex justify-between align-middle"
        role="button"
        id={`sectionOpenTrigger-${section.id}`}
        onClick={() => setSectionOpen(!sectionOpen)}
      >
        <div className="flex flex-col justify-center">
          <H3
            description={section.description}
            className="text-primary-700 text-align-center"
          >
            {displayedIndex}. {section.title}
          </H3>
        </div>
        <div className="flex flex-col justify-center">
          <ChevronDownIcon iconClassName="text-dark-100 w-6 h-6" />
        </div>
      </div>
      <div
        id={`section-${section.id}`}
        className={`transform space-y-10 transition-all ${
          sectionOpen ? "pt-8 opacity-100" : "opacity-0 hidden h-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default React.memo(TemplateSection);
